import { useTranslation } from "react-i18next";
import {
  AbsenceButtonWrapper,
  DetailsBreakdown,
  ReservationDetailsWrapper,
} from "./styles";
import AirbnbIcon from "@assets/svg/airbnb.svg?react";
import GathernIcon from "@assets/svg/GathernIcon2.svg?react";
import BookingIcon from "@assets/svg/BookingIcon.svg?react";
import ChannelAgoda from "@assets/svg/ChannelAgoda.svg?react";
import MsoolIcon from "@assets/svg/msool-icon.svg?react";
import MoneysIcon from "@assets/svg/MoneysIcon.svg?react";
import IconMessage from "@assets/svg/IconMessage.svg?react";
import CalendarTick from "@assets/svg/calendarTick.svg?react";
import HomeIcon from "@assets/svg/HomeIcon.svg?react";
import UserOctagon from "@assets/svg/userOctagon.svg?react";
import { useRecoilValue } from "recoil";
import { loaderState, reservationDetails } from "@store/index";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { ToastMessageContext } from "@context/toast-message-cotnext";
import { ContentCopyOutlined } from "@mui/icons-material";
import DetailsInfo from "./detailsInfo";
import PopupConfirmationSendMesseg from "./popupConfirmationSendMesseg";
import ActionView from "./actionView";
import PopupEnableSmartEntryFeature from "./popupEnableSmartEntryFeature";
import PopupDisableLock from "./popupDisableLock";
import CustomLoading from "../../../../../CustomLoading";
import CustomButton from "@Common/CustomButton";
import CancelReservationPopup from "./cancelReservation";
import EditReservationPopup from "./editReservation";
import { useSubPermissions } from "@hooks/usePermissions";
import AbsensePopup from "./absensePopup";
import { useCalendar, useGetCalenderData, useGetUserDetail } from "@services";
import {
  DirectPaymentContainer,
  DirectPaymentSubtitle,
  DirectPaymentTextContainer,
  DirectPaymentTitle,
} from "../../../../../../components/manualReservation_v2/bookingInformationForm/styles";
import { Toggle } from "@components";
import useBreakPoinst from "@hooks/useBreakPoinst";
import { Button } from "@mui/material";
import POPReservationCancellation from "./popReservationCancellation";
interface IChannals {
  Airbnb: JSX.Element;
  GatherIn: JSX.Element;
  Booking: JSX.Element;
  Agoda: JSX.Element;
  Msool: JSX.Element;
}
const channals: IChannals = {
  Airbnb: <AirbnbIcon />,
  GatherIn: <GathernIcon />,
  Booking: <BookingIcon />,
  Agoda: <ChannelAgoda />,
  Msool: <MsoolIcon />,
};

export default function ReservationDetails() {
  const [loading, setLoading] = useState(false);
  const { NoShowBookingMutate } = useCalendar();
  const { isPhone } = useBreakPoinst();
  const { data: userData } = useGetUserDetail();
  const isUserPaymentActive = (userData?.result as any)?.isUserPaymentActive;
  const { showCalendarSendReservationDetails, showCalendarEditReservations } =
    useSubPermissions();
  const [
    isPopupConfirmationSendMessegOpen,
    setIsPopupConfirmationSendMessegOpen,
  ] = useState(false);
  const [isAbsensePopupOpen, setIsAbsensePopupOpen] = useState(false);
  const [isOpenCancelReservationPopup, setIsOpenCancelReservationPopup] =
    useState(false);
  const [isOpenEditReservationPopup, setIsOpenEditReservationPopup] =
    useState(false);
  const isloaderState = useRecoilValue(loaderState);

  const [isPopupEnableSmartEntryFeature, setIsPopupEnableSmartEntryFeature] =
    useState(false);
  const [isPopupDisableLock, setIsPopupDisableLock] = useState(false);
  const reservationDetailsValue = useRecoilValue(reservationDetails);
  console.log("sultanreservationDetailsValue", reservationDetailsValue);
  const [ready, setReady] = useState(false);
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { showSuccess } = useContext(ToastMessageContext);
  const checkOut = dayjs(reservationDetailsValue?.checkOut).format(
    "YYYY-MM-DD"
  );
  const isBeforeDate = dayjs().isBefore(checkOut, "month");
  const styleStatus = () => {
    const status = reservationDetailsValue?.bookingStatus;
    if (status === "مؤكد" || status === "new") {
      return "green";
    }
    if (status === "cancelled" || status === "ملغي") {
      return "gray";
    }
    return "yellow";
  };

  const handleCopyClick = () => {
    if (!reservationDetailsValue?.reservationId) return;
    navigator.clipboard
      .writeText(reservationDetailsValue?.reservationId)
      .then(() => {
        showSuccess(t("COMMON.RESERVATION_COPIED"));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  useEffect(() => {
    setTimeout(() => {
      setReady(true);
    }, 1000);
  }, []);
  const noShowMutation = NoShowBookingMutate({
    onError(error) {
      setIsAbsensePopupOpen(false);
      setLoading(false);
    },
    onSuccess: (d: any) => {
      setIsAbsensePopupOpen(false);
      let message =
        language == "ar"
          ? "تم تحديد الحجز كعدم حضور بنجاح، وتم فتح التوافر عبر جميع المنصات المتصلة"
          : "The booking has been successfully marked as no-show and availability has been opened across all connected platforms";

      showSuccess(message);
      setTimeout(() => {
        window.location.reload();
      }, 300);
    },
  });

  const handleNoShowBooking = async () => {
    if (!reservationDetailsValue?.id) {
      return;
    }
    try {
      setLoading(true);
      await noShowMutation.mutateAsync(reservationDetailsValue?.id);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const isManual =
    reservationDetailsValue?.channelName === "Booking" ||
    reservationDetailsValue?.channelName === "Airbnb";
  return (
    <ReservationDetailsWrapper status={styleStatus()}>
      {isloaderState && <CustomLoading />}
      <CancelReservationPopup
        isOpen={isOpenCancelReservationPopup}
        setIsOpen={setIsOpenCancelReservationPopup}
      />
      <AbsensePopup
        loading={loading}
        onClick={handleNoShowBooking}
        isOpen={isAbsensePopupOpen}
        setIsOpen={setIsAbsensePopupOpen}
      />
      <EditReservationPopup
        isOpen={isOpenEditReservationPopup}
        setIsOpen={setIsOpenEditReservationPopup}
      />
      {isPopupConfirmationSendMessegOpen &&
        showCalendarSendReservationDetails && (
          <PopupConfirmationSendMesseg
            setIsPopupConfirmationSendMessegOpen={
              setIsPopupConfirmationSendMessegOpen
            }
          />
        )}
      {isPopupEnableSmartEntryFeature && (
        <PopupEnableSmartEntryFeature
          setIsPopupEnableSmartEntryFeature={setIsPopupEnableSmartEntryFeature}
        />
      )}
      {isPopupDisableLock && (
        <PopupDisableLock setIsPopupDisableLock={setIsPopupDisableLock} />
      )}
      <div className="containerHeader">
        <p>{t("CALENDAR.RESERVATIONDETAILS")}</p>
        {reservationDetailsValue?.bookingStatus !== "cancelled" &&
          reservationDetailsValue?.bookingStatus !== "ملغي" &&
          reservationDetailsValue?.channelName.toLocaleLowerCase() ===
            "msool" &&
          showCalendarEditReservations && (
            <div className="containerButtons">
              <CustomButton
                label={t("COMMON.BOOKING_UPDATED")}
                withBG
                customPadding="12px 22px"
                borderRadius="8px"
                onClick={() => setIsOpenEditReservationPopup(true)}
              />
              <CustomButton
                label={t("MANUALRESERVATION.CANCELLATIONOFRESERVATION")}
                customBG="#fdf0f0"
                customColor="#E85B5B"
                borderColor="#fdf0f0"
                customPadding="12px 22px"
                borderRadius="8px"
                onClick={() => setIsOpenCancelReservationPopup(true)}
              />
            </div>
          )}
      </div>
      {/* <AbsenceButtonWrapper
        onClick={() => setIsAbsensePopupOpen(true)}
        show={
          reservationDetailsValue?.channelName.toLocaleLowerCase() === "booking"
        }
      >
        <button>
          <h6>{t("MANUALRESERVATION.ABSENCE")}</h6>
        </button>
      </AbsenceButtonWrapper> */}
      <div className="channalAndStatus">
        <div className="channal">
          <div>
            {reservationDetailsValue?.channelName &&
              channals[reservationDetailsValue?.channelName]}
          </div>
          <p>{reservationDetailsValue?.channelName}</p>
        </div>

        {reservationDetailsValue?.bookingStatus && (
          <div className="status">
            <span></span>
            <span>{reservationDetailsValue?.bookingStatus}</span>
          </div>
        )}
      </div>
      <div className="infoSection">
        <div>
          <div className="iconSection">
            <UserOctagon />
          </div>
          <div className="titleSection">
            <p>{t("Reservation.GuestName")}</p>
          </div>
          <div className="detailsSection">
            <p>{reservationDetailsValue?.guestName}</p>
            <p className="guestPhoneNumber">
              <span>{reservationDetailsValue?.guestPhoneNumber}</span>
            </p>
          </div>
        </div>
        <div>
          <div className="iconSection">
            <HomeIcon />
          </div>
          <div className="titleSection">
            <p>{t("COMMON.PROPERTY")}</p>
          </div>
          <div className="detailsSection">
            <p>{reservationDetailsValue?.propertyName}</p>
            <p>
              <span>{t("Reservation.BookingNum")} : </span>
              <span>{reservationDetailsValue?.reservationId}</span>
              <div
                className="handleCopyClick"
                onClick={() => handleCopyClick()}
              >
                <ContentCopyOutlined sx={{ width: "16px" }} />
              </div>
            </p>
          </div>
        </div>
        {reservationDetailsValue?.channelName.toLocaleLowerCase() !==
          "msool" && (
          <POPReservationCancellation id={reservationDetailsValue?.id} />
        )}
      </div>
      <div className="dateAndTimeSection">
        <div className="iconSection">
          <CalendarTick />
        </div>
        <div className="titleSection">
          <p>{t("MANUALRESERVATION.TIMEANDDATE")}</p>
        </div>
        <div className="dateAndTime">
          <div className="cotainer">
            <p>
              {t("CALENDAR.CHECK_IN")}:{" "}
              {reservationDetailsValue?.checkIn &&
                dayjs(reservationDetailsValue?.checkIn).format("YYYY-MM-DD")}
            </p>
            <div className="time">
              {reservationDetailsValue?.checkOut &&
                dayjs(reservationDetailsValue?.checkIn).format("HH-MM A")}
            </div>
          </div>
        </div>
        <div className="dateAndTime">
          <div className="cotainer">
            <p>
              {t("CALENDAR.CHECK_OUT")}:{" "}
              {reservationDetailsValue?.checkIn &&
                dayjs(reservationDetailsValue?.checkOut).format("YYYY-MM-DD")}
            </p>
            <div className="time">
              {reservationDetailsValue?.checkOut &&
                dayjs(reservationDetailsValue?.checkOut).format("HH-MM A")}
            </div>
          </div>
        </div>
      </div>
      <div className="pricingSection">
        <div className="iconSection">
          <MoneysIcon />
        </div>
        <div className="titleSection">
          <p>{t("COMMON.PRICING")}</p>
        </div>
        <div className="detailsSection">
          {isManual && reservationDetailsValue?.total?.taxes?.length ? (
            <DetailsBreakdown>
              <span className="line bold">
                <p>{t("COMMON.SUBTOTAL")}</p>
                <p>{`${reservationDetailsValue?.total?.amount_befre_tax} ${reservationDetailsValue?.total?.currency_code}`}</p>
              </span>
              {reservationDetailsValue?.total?.taxes?.map(
                (c: any, i: number) => (
                  <span key={String(i)} className="line bold">
                    <p>{c?.tax_description}</p>
                    <p>{`${c?.amount_decimal} ${c?.currency_code}`}</p>
                  </span>
                )
              )}
              <span className="line total">
                <p>{t("MANUALRESERVATION.TOTALPRICE")} :</p>
                <p>
                  {`${reservationDetailsValue?.totalPrice} ${
                    isManual
                      ? reservationDetailsValue?.total?.currency_code ??
                        t("GENERAL.SR")
                      : t("GENERAL.SR")
                  }`}
                </p>
              </span>
            </DetailsBreakdown>
          ) : !ready ? null : (
            <p>
              <span>{t("MANUALRESERVATION.TOTALPRICE")} : </span>
              <span>
                {reservationDetailsValue?.totalPrice} {t("GENERAL.SR")}
              </span>
            </p>
          )}
        </div>
      </div>
      <DirectPaymentContainer $isPhone={isPhone}>
        <DirectPaymentTextContainer $isPhone={isPhone}>
          <DirectPaymentTitle $isPhone={isPhone}>
            {t("MANUALRESERVATION.DIRECT_PAYMENT_RECEIPT")}
          </DirectPaymentTitle>
          <DirectPaymentSubtitle $isPhone={isPhone}>
            {t("MANUALRESERVATION.PAYMENT_LINK_DESCRIPTION")}
          </DirectPaymentSubtitle>
        </DirectPaymentTextContainer>
        <Toggle
          disabled={true}
          checked={reservationDetailsValue?.isDirectPaymentAccepted}
        />
      </DirectPaymentContainer>
    </ReservationDetailsWrapper>
  );
}
